export const FIRST_LIMIT_CONSTANT = 11
export const LIMIT_CONSTANT = 12
export const MAX_SIZE_DOCUMENT = process.env.REACT_APP_MAX_SIZE_DOCUMENT
export const MAX_DOCUMENT_BYTES = process.env.REACT_APP_MAX_DOCUMENT_BYTES
export const MAX_SIZE_VIDEO = process.env.REACT_APP_MAX_SIZE_VIDEO
export const MAX_VIDEO_BYTES = process.env.REACT_APP_MAX_VIDEO_BYTES
export const DOCUMENT_TYPES = process.env.REACT_APP_VALID_FILE_TYPES
